// features/language/languageSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  lang: localStorage.getItem('lang') || 'en', 
  currency: localStorage.getItem('currency') || 'EUR', 
};


const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.lang = action.payload;
      localStorage.setItem('lang', action.payload);
    },
    setCurrency: (state, action) => {
        state.currency = action.payload;
        localStorage.setItem('currency', action.payload);
    },
  },
});

export const { setLanguage, setCurrency } = languageSlice.actions;
export default languageSlice.reducer;